<ion-content class="form-content" *ngIf="authServ.isLogged; else noLogged">
  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <h1>{{ menuItem.name | caption | translate }}</h1>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">
    <ion-row class="ion-text-center top-rows">
      <ion-col size="10/3">
        <ion-text [color]="reservationDate ? 'primary' : 'medium'">
          <b>{{ "Date" | translate }}</b>
        </ion-text>
      </ion-col>
      <ion-col size="1">
        <ion-icon name="chevron-forward" [color]="reservationDate ? 'primary' : 'medium'"></ion-icon>
      </ion-col>
      <ion-col size="10/3">
        <ion-text [color]="bookPax ? 'primary' : 'medium'">
          <b>{{ "Body Count" | translate }}</b>
        </ion-text>
      </ion-col>
      <ion-col size="1">
        <ion-icon name="chevron-forward" [color]="bookPax ? 'primary' : 'medium'"></ion-icon>
      </ion-col>
      <ion-col size="10/3">
        <ion-text [color]="bookTime ? 'primary' : 'medium'">
          <b>{{ "Time" | translate }}</b>
        </ion-text>
      </ion-col>

      <ion-col size="10/3">
        <ion-text color="primary">
          <span *ngIf="!reservationDate">-</span> {{ reservationDate }}
        </ion-text>
      </ion-col>
      <ion-col size="1"></ion-col>
      <ion-col size="10/3">
        <ion-text color="primary">
          <span *ngIf="!bookPax">-</span>
          <span *ngIf="bookPax"> {{ bookPax + childPax +infantPax }}</span>
        </ion-text>
      </ion-col>
      <ion-col size="1"></ion-col>
      <ion-col size="10/3">
        <ion-text color="primary">
          <span *ngIf="!bookTime">-</span> {{ bookTime }}
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="showDropdown">
      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked">{{
            "Reservation Program" | translate
            }}</ion-label>
          <ng-container *ngIf="cantSuitable;else canSuitable">
            <ion-text color="medium">
              <h4>{{"No suitable reservation calendar was found." | translate }}</h4>
            </ion-text>
          </ng-container>
          <ng-template #canSuitable>
            <ion-select [(ngModel)]="selectedDetail" (ionChange)="updateSelect()"
                        placeholder="{{ 'Please Select' | translate }}">

              <ng-container *ngFor="let book of menuItem.menu_item_books">
                <ng-container *ngFor="let detail of book.menu_item_book_details">

                  <ion-select-option [value]="detail">
                    {{ detail.name | caption | translate }}
                  </ion-select-option>

                </ng-container>


              </ng-container>
            </ion-select>
          </ng-template>

        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="selectedDetail && step === 0">
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h3 class="ion-no-margin">
            <b>
              {{ "Date" | translate }}
            </b>
          </h3>
        </ion-text>
      </ion-col>

      <ng-container *ngIf="this.menuItem.show_booking_date;else normal">
        <ng-container *ngFor="
            let day of [].constructor(selectedBook.bookable_in_advance_days || 4);
            let i = index
          ">
          <ion-col class="day-cards" size="6" *ngIf="selectedBook[(today | dateAdd: i:'day':'dddd').toLowerCase()]
              && (selectedDetail.start_time | date:'yyyy-MM-dd') <= (today | dateAdd: i:'day':'YYYY-MM-DD')
              && (selectedDetail.end_time | date:'yyyy-MM-dd') >= (today | dateAdd: i:'day':'YYYY-MM-DD')
              && isBlockOut(i)">

            <input [checked]="reservationDate === dayRadio.value" [value]="today | dateAdd: i:'day':'YYYY-MM-DD'"
                   type="radio" name="days" #dayRadio id="d{{ i }}" class="ion-hide"/>
            <label (click)="reservationDate = dayRadio.value; step = 1" appEqualWidthHeight equalWith="width"
                   for="d{{ i }}">
              <span>{{ today | dateAdd: i:"day":"DD/MM" }}</span>
              <span>{{
                today | dateAdd: i:"day":"dddd" | lowercase | translate
                }}</span>
            </label>
          </ion-col>
        </ng-container>
      </ng-container>
      <ng-template #normal>
        <ng-container *ngFor="
              let day of [].constructor(selectedBook.bookable_in_advance_days || 4);
              let i = index
            ">
          <ion-col class="day-cards" size="6" *ngIf="selectedBook[(today | dateAdd: i:'day':'dddd').toLowerCase()] && isBlockOut(i)">
            <input [checked]="reservationDate === dayRadio.value" [value]="today | dateAdd: i:'day':'YYYY-MM-DD'"
                   type="radio" name="days" #dayRadio id="d{{ i }}" class="ion-hide"/>
            <label (click)="reservationDate = dayRadio.value; step = 1" appEqualWidthHeight equalWith="width"
                   for="d{{ i }}">
              <span>{{ today | dateAdd: i:"day":"DD/MM" }}</span>
              <span>{{
                today | dateAdd: i:"day":"dddd" | lowercase | translate
                }}</span>
            </label>
          </ion-col>
        </ng-container>
      </ng-template>

      <ion-col size="12" *ngIf="dayNotFound" class="error">
        <ion-icon color="medium" name="search-outline" style="font-size: 128px;"></ion-icon>
        <br>
        <ion-text color="medium">
          <h2>{{"Available days not found." | translate }}</h2>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="step === 1">
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h3 class="ion-no-margin">
            <b>
              {{ "Adult" | translate }}
            </b>
          </h3>
        </ion-text>
      </ion-col>
      <ng-container *ngFor="let day of [].constructor(paxCardCount); let i = index">
        <ion-col class="day-cards" size="12/5">

          <ng-container *ngIf="paxMinLimit>0">
            <input [checked]="bookPax === +paxRadio.value" [value]="paxMinLimit + i" type="radio" name="pax" #paxRadio
                   id="p{{ paxMinLimit + i }}" class="ion-hide"/>
            <label (click)="bookPax = +paxRadio.value; cartServ.cover = bookPax" appEqualWidthHeight equalWith="width"
                   for="p{{ paxMinLimit + i }}">
              <span>{{ paxMinLimit + i }}</span>
            </label>
          </ng-container>

          <ng-container *ngIf="paxMinLimit === 0">
            <input [checked]="bookPax === +paxRadio.value" [value]="paxMinLimit + (i + 1)" type="radio" name="pax"
                   #paxRadio id="p{{ paxMinLimit + (i + 1) }}" class="ion-hide"/>
            <label (click)="bookPax = +paxRadio.value; cartServ.cover = bookPax" appEqualWidthHeight equalWith="width"
                   for="p{{ paxMinLimit + (i + 1) }}">
              <span>{{ paxMinLimit + (i + 1) }}</span>
            </label>
          </ng-container>

        </ion-col>
      </ng-container>

      <ng-container *ngIf="dataServ.rData.child_age_range && selectedDetail.is_child_accept">
        <ion-col size="12">
          <br/>
          <ion-text color="primary" class="ion-text-center">
            <h3 class="ion-no-margin">
              <b>
                {{ "Child" | translate }} ({{ dataServ.rData.child_age_range }})
              </b>
            </h3>
          </ion-text>
        </ion-col>
        <ng-container *ngFor="let day of [].constructor(5); let i = index">
          <ion-col class="day-cards" size="12/5">
            <input [checked]="childPax === +paxRadio.value" [value]="i" type="radio" name="paxc" #paxRadio
                   id="pc{{ i }}" class="ion-hide"/>
            <label (click)="childPax = +paxRadio.value;" appEqualWidthHeight equalWith="width" for="pc{{ i }}">
              <span>{{ i }}</span>
            </label>
          </ion-col>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="dataServ.rData.baby_age_range && selectedDetail.is_child_accept">
        <ion-col size="12">
          <br/>
          <ion-text color="primary" class="ion-text-center">
            <h3 class="ion-no-margin">
              <b>
                {{ "Infant" | translate }} ({{ dataServ.rData.baby_age_range }})
              </b>
            </h3>
          </ion-text>
        </ion-col>
        <ng-container *ngFor="let day of [].constructor(5); let i = index">
          <ion-col class="day-cards" size="12/5">
            <input [checked]="infantPax === +paxRadio.value" [value]="i" type="radio" name="paxi" #paxRadio
                   id="pi{{ i }}" class="ion-hide"/>
            <label (click)="infantPax = +paxRadio.value" appEqualWidthHeight equalWith="width" for="pi{{ i }}">
              <span>{{ i }}</span>
            </label>
          </ion-col>
        </ng-container>
      </ng-container>
    </ion-row>

    <ion-row *ngIf="step === 2">
      <ion-col size="12">
        <ng-container *ngIf="dataServ.menuItem.fix_menu">
          <ion-col size="12">
            <app-catalog [disablePeopleSelector]="true"></app-catalog>
          </ion-col>
        </ng-container>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="selectedDetail && step === 3" class="times">
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h3 class="ion-no-margin">
            <b>
              {{ "Time" | translate }}
            </b>
          </h3>
        </ion-text>
      </ion-col>

      <ng-container *ngIf="reservationHours && reservationHours.length > 0; else noTimeTemp">
        <ion-col class="day-cards time" size="4">
          <label (click)="step = step - 1">
            <div>
              <ion-icon name="chevron-back"></ion-icon>
              {{ "Back" | translate }}
            </div>
          </label>
        </ion-col>

        <ion-col class="day-cards time" size="4" *ngFor="let hour of reservationHours; let i = index">
          <input #timeInput [checked]="bookTime === timeInput.value" [value]="hour.hour" type="radio" name="time"
                 id="t{{ i }}" class="ion-hide"/>

          <label (click)="bookTime = hour.hour; selectedHour = hour;" for="t{{ i }}">
            {{ hour.hour }}
          </label>
        </ion-col>
      </ng-container>

      <ng-template #noTimeTemp>
        <ion-col size="12" sizeLg="8" offsetLg="2" class="no-time" appEqualWidthHeight equalWith="width">
          <ion-icon name="close" color="primary"></ion-icon>
          <ion-text color="primary" class="ion-text-center">
            <h3>
              <b>
                {{ "Closed" | translate }}
              </b>
            </h3>
          </ion-text>
        </ion-col>
      </ng-template>
    </ion-row>

    <ion-row *ngIf="step === 4">
      <app-extra-forms></app-extra-forms>

      <ion-col size="12">
        <ion-item>
          <ion-textarea rows="4" #noteInput placeholder="{{ 'Note' | translate }}"></ion-textarea>
        </ion-item>
      </ion-col>

      <ion-col size="12">
        <ion-button (click)="send(noteInput.value)" expand="block" color="primary">
          {{ "Send" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-row *ngIf="step > 0 && step < 4">
  <ion-col>
    <ion-button (click)="step = step - 1" expand="block" class="back-row" fill="clear">
      <ion-icon slot="start" name="chevron-back"></ion-icon>
      {{ "Back" | translate }}
    </ion-button>
  </ion-col>

  <ion-col *ngIf="
      step !== 3 ||
      (reservationHours && reservationHours.length > 0 && bookTime)
    ">
    <ion-button (click)="addStep()" expand="block" class="back-row" fill="clear">
      <ion-icon slot="end" name="chevron-forward"></ion-icon>
      {{ "Next" | translate }}
    </ion-button>
  </ion-col>
</ion-row>

<ng-template #noLogged>
  <ion-button (click)="close()" fill="clear" color="light" class="ion-no-padding login-back">
    <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
  </ion-button>
  <app-profile></app-profile>
</ng-template>
